<app-top-navigation [openLoginWindow]="isLoginOpen"></app-top-navigation>
<div class="containerCenter">
	<h4>
		{{"TRANS_REMOTE_ABOUT.TRANS_ABOUT_TITLE" | translate}}
	</h4>
	<div class="description" [innerHTML]="'TRANS_REMOTE_ABOUT.TRANS_MAIN_PARAGRAPH' | translate">

	</div>
	<div class="m-t-20">
		<h4>
			{{"TRANS_REMOTE_ABOUT.TRANS_CONTACT_INFO" | translate}}
		</h4>
		<div class="row">
			<div class="col-md-6"> <fa-icon [icon]="['fas','map-marker-alt']"></fa-icon> {{"TRANS_REMOTE_ABOUT.TRANS_ADDRESS" | translate}} </div>
			<div class="col-md-6"> <fa-icon [icon]="['fas','mobile-alt']"></fa-icon> +30 6947150848 </div>
			<div class="col-md-6"> <fa-icon [icon]="['fas','phone-alt']"></fa-icon> +30 2109963757 </div>
			<div class="col-md-6"> <fa-icon [icon]="['fas','envelope']"></fa-icon> info[@]cultureapp.eu </div>
		</div>
	</div>
	<div class="map text-center m-t-20">
		<iframe
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1623.7119896543347!2d23.74543322412093!3d37.91419669625442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bde3f01865c3%3A0xc762ad74b50278d1!2sLeof.%20Kiprou%2010%2C%20Argiroupoli%20164%2051!5e0!3m2!1sen!2sgr!4v1623138583425!5m2!1sen!2sgr"
				width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
	</div>
</div>